/** Firestore is limited to 10 values when using in, not-in and array-contans-any. */
export const firestoreMaxClauses = 10;
